<div class="container" style="display:flex; flex-direction:column; align-items:center;">
  <h3>Sikeres Regisztráció!</h3>
  <p>Köszönöm, hogy regisztráltál! A menüpontok között a <b>Bejelentkezés</b> gombra kattinva a megadott e-mail címeddel és jelszavaddal már be is léphetsz!</p>
</div>
